import Layout from "./Layout.jsx";
import Home from "./Home";
import Impressum from "./Impressum";
import Datenschutz from "./Datenschutz";
import Barrierefreiheitserklaerung from "./Barrierefreiheitserklaerung";
import Hausordnung from "./Hausordnung";
import Gebuehrenordnung from "./Gebuehrenordnung";
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';

/**
 * Verfügbare Seiten der Anwendung
 * Wird für das Routing und die Seitenbestimmung verwendet
 * 
 * Jede Seite ist eine React-Komponente, die in der Anwendung
 * über ihre URL aufgerufen werden kann
 */
const PAGES = {
    Home: Home,
    Impressum: Impressum,
    Datenschutz: Datenschutz,
    Barrierefreiheitserklaerung: Barrierefreiheitserklaerung,
    Hausordnung: Hausordnung,
    Gebuehrenordnung: Gebuehrenordnung,
}

/**
 * Bestimmt die aktuelle Seite basierend auf der URL
 * Normalisiert die URL und findet die passende Seitenkomponente
 * 
 * @param {string} url - Aktuelle URL (z.B. "/", "/home", "/about")
 * @returns {string} Name der aktuellen Seite (z.B. "Home", "About")
 * 
 * @example
 * _getCurrentPage("/") // → "Home"
 * _getCurrentPage("/home") // → "Home"
 * _getCurrentPage("/about") // → "About"
 */
function _getCurrentPage(url) {
    // Entferne trailing slash
    if (url.endsWith('/')) {
        url = url.slice(0, -1);
    }
    
    // Extrahiere den letzten Teil der URL
    let urlLastPart = url.split('/').pop();
    
    // Entferne Query-Parameter falls vorhanden
    if (urlLastPart.includes('?')) {
        urlLastPart = urlLastPart.split('?')[0];
    }

    // Finde die passende Seite basierend auf dem URL-Teil
    const pageName = Object.keys(PAGES).find(page => page.toLowerCase() === urlLastPart.toLowerCase());
    
    // Fallback: Verwende die erste verfügbare Seite
    return pageName || Object.keys(PAGES)[0];
}

/**
 * Wrapper-Komponente, die useLocation innerhalb des Router-Kontexts verwendet
 * Ermöglicht den Zugriff auf die aktuelle URL für die Seitenbestimmung
 * 
 * Diese Komponente muss innerhalb eines Router-Kontexts stehen,
 * da sie den useLocation-Hook verwendet
 */
function PagesContent() {
    const location = useLocation();
    const currentPage = _getCurrentPage(location.pathname);
    
    return (
        <Layout currentPageName={currentPage}>
            <Routes>            
                <Route path="/" element={<Home />} />
                <Route path="/home" element={<Home />} />
                <Route path="/impressum" element={<Impressum />} />
                <Route path="/datenschutz" element={<Datenschutz />} />
                <Route path="/barrierefreiheitserklaerung" element={<Barrierefreiheitserklaerung />} />
                <Route path="/hausordnung" element={<Hausordnung />} />
                <Route path="/gebuehrenordnung" element={<Gebuehrenordnung />} />
                <Route path="*" element={<Home />} />
            </Routes>
        </Layout>
    );
}

/**
 * Hauptkomponente für das Routing
 * Setzt den Router und rendert die Seiten mit dem Layout
 * 
 * Diese Komponente ist der Einstiegspunkt für das Routing
 * und stellt sicher, dass alle Seiten im richtigen Kontext stehen
 */
export default function Pages() {
    return (
        <Router>
            <PagesContent />
        </Router>
    );
}